import constants from '~/utils/constants';

/**
 * NOVA-632
 *
 * Update default sort values, persist `routesDrawerSort` between login sessions
 */
export default function (state) {
    return {
        ...state,
        routesDrawerSort: {
            plan: {
                sortMetric: constants.sortOptionKeys.STOP_COUNT,
                sortDirection: constants.sortOrder.DESC
            },
            dispatched: {
                sortMetric: constants.sortOptionKeys.STOP_COUNT,
                sortDirection: constants.sortOrder.DESC
            },
            completed: {
                sortMetric: constants.sortOptionKeys.STOP_COUNT,
                sortDirection: constants.sortOrder.DESC
            }
        }
    };
}
